module.exports = __webpack_public_path__ + "static/img/5.19398f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/pharmacy/1/5.png
// module id = NHEP
// module chunks = 1